import styled from 'styled-components';
import Colors from '@/v2/constants/Colors';

export default function RadioButton({ selected }: { selected: boolean }) {
  return (
    <div>
      <RadioButtonStyled selected={selected} />
    </div>
  );
}

interface RadioButtonStyledProps {
  selected?: boolean;
}

const RadioButtonStyled = styled.div<RadioButtonStyledProps>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${Colors.BLACK};
  position: relative;

  ${(props) =>
    props.selected &&
    `border-color: ${Colors.MAIN_VARIANTS[60]};
    &::after {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: ${Colors.MAIN_VARIANTS[60]};
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
   `}
`;
